









































































































































import { Component, Vue } from 'vue-property-decorator';

import DraggableWidget from '@/components/util/DraggableWidget.vue';

import { User } from 'oidc-client';
import { mapGetters } from 'vuex';

import {
  WorkordersApi,
  QueryWorkOrdersRequest,
  WorkorderPagedCollectionApiResponse,
  PerformoSettings
} from 'performo-api';

@Component({
  components: {
    DraggableWidget
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    api: 'ordersApi',
    settings: 'settings'
  })
})
export default class WorkerButtonsWidget extends Vue {
  private api!: WorkordersApi;
  private settings!: PerformoSettings;

  private currentPropertyId!: string;
  private currentUser!: User;

  private mineTeamAll!: number; // 3 = all; 1 = mine; 2 = team; only applies within this component

  private openOrders!: number;
  private priorityOneOrders!: number;
  private overdueOrders!: number;
  private cmOrders!: number;
  private pmOrders!: number;
  private reqOrders!: number;

  private openOrdersQuery!: QueryWorkOrdersRequest;
  private priorityOneOrdersQuery!: QueryWorkOrdersRequest;
  private overdueOrdersQuery!: QueryWorkOrdersRequest;
  private cmOrdersQuery!: QueryWorkOrdersRequest;
  private pmOrdersQuery!: QueryWorkOrdersRequest;
  private reqOrdersQuery!: QueryWorkOrdersRequest;

  data() {
    return {
      mineTeamAll: undefined,
      openOrders: undefined,
      priorityOneOrders: undefined,
      overdueOrders: undefined,
      cmOrders: undefined,
      pmOrders: undefined,
      reqOrders: undefined,
      openOrdersQuery: undefined,
      priorityOneOrdersQuery: undefined,
      overdueOrdersQuery: undefined,
      cmOrdersQuery: undefined,
      pmOrdersQuery: undefined,
      reqOrdersQuery: undefined
    };
  }

  private storeMineTeamAll(value: number) {
    if (value) {
      window.localStorage.setItem('homebuttonsMineTeamAll', value.toString());
    }
  }

  get currentOpenOrdersQuery() {
    this.fetchOpenOrders();
    return this.openOrdersQuery;
  }

  private async fetchOpenOrders() {
    this.openOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      includeSubStatuses:
        this.settings.openSubStatuses && this.settings.openSubStatuses.length
          ? true
          : undefined
    };

    if (this.mineTeamAll == 1) {
      this.openOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll == 2) {
      this.openOrdersQuery.tradeTeam = this.currentUser.profile.TradeTeam;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.openOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.openOrders = pagedOrders.pagination.totalItems;
    } else {
      this.openOrders = 0;
    }
  }

  get currentPriorityOneOrdersQuery() {
    this.fetchPriorityOneOrders();
    return this.priorityOneOrdersQuery;
  }

  private async fetchPriorityOneOrders() {
    this.priorityOneOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      jobPriority: 1
    };

    if (this.mineTeamAll == 1) {
      this.priorityOneOrdersQuery.assignTo =
        this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll == 2) {
      this.priorityOneOrdersQuery.tradeTeam =
        this.currentUser.profile.TradeTeam;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.priorityOneOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.priorityOneOrders = pagedOrders.pagination.totalItems;
    } else {
      this.priorityOneOrders = 0;
    }
  }

  get currentOverdueOrdersQuery() {
    this.fetchOverdueOrders();
    return this.overdueOrdersQuery;
  }

  private async fetchOverdueOrders() {
    this.overdueOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Overdue'
    };

    if (this.mineTeamAll == 1) {
      this.overdueOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll == 2) {
      this.overdueOrdersQuery.tradeTeam = this.currentUser.profile.TradeTeam;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.overdueOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.overdueOrders = pagedOrders.pagination.totalItems;
    } else {
      this.overdueOrders = 0;
    }
  }

  get currentCMOrdersQuery() {
    this.fetchCMOrders();
    return this.cmOrdersQuery;
  }

  private async fetchCMOrders() {
    this.cmOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      orderCategory: 'CM'
    };

    if (this.mineTeamAll == 1) {
      this.cmOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll == 2) {
      this.cmOrdersQuery.tradeTeam = this.currentUser.profile.TradeTeam;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.cmOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.cmOrders = pagedOrders.pagination.totalItems;
    } else {
      this.cmOrders = 0;
    }
  }

  get currentPMOrdersQuery() {
    this.fetchPMOrders();
    return this.pmOrdersQuery;
  }

  private async fetchPMOrders() {
    this.pmOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      orderCategory: 'PM'
    };

    if (this.mineTeamAll == 1) {
      this.pmOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll == 2) {
      this.pmOrdersQuery.tradeTeam = this.currentUser.profile.TradeTeam;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.pmOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.pmOrders = pagedOrders.pagination.totalItems;
    } else {
      this.pmOrders = 0;
    }
  }

  get currentREQOrdersQuery() {
    this.fetchREQOrders();
    return this.reqOrdersQuery;
  }

  private async fetchREQOrders() {
    this.reqOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      orderCategory: 'REQ'
    };

    if (this.mineTeamAll == 1) {
      this.reqOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll == 2) {
      this.reqOrdersQuery.tradeTeam = this.currentUser.profile.TradeTeam;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.reqOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.reqOrders = pagedOrders.pagination.totalItems;
    } else {
      this.reqOrders = 0;
    }
  }

  private doWorkerButtonsWidget() {
    // blank
  }

  created() {
    const mta = window.localStorage.getItem('homebuttonsMineTeamAll');
    if (mta) {
      this.mineTeamAll = parseInt(mta);
    } else {
      this.mineTeamAll = 1;
    }
  }
}
